<div class="container">
  <extension-header
    [type]="type"
    (onCancel)="cancel()"
    (onAddComponent)="handleAddExtension($event)"
    [loadingExtension]="(extensionDetailLoading$ | async) ?? false"
    [saveDisabled]="isSaveDisabled"
    [showMetrics]="enableMetrics && (loadedExtension$ | async)"
    (onSave)="extensionsService.triggerSave()"></extension-header>

  <!--COMPONENTS-->
  <div class="content">
    <div class="components-section">
      @if (extensionDetailLoading$ | async) {
        <extension-edit-loader></extension-edit-loader>
      } @else {
        <router-outlet></router-outlet>
      }
    </div>

    <!--LIVE CHECKOUT EXAMPLE-->
    <div class="live-example-section">
      @if (extensionDetailLoading$ | async) {
        <extension-edit-loader></extension-edit-loader>
      } @else {
        <pdq-card variant="popover" color="white">
          <checkout-example [shop]="shop$ | async"></checkout-example
        ></pdq-card>
      }
    </div>
  </div>
</div>
